<div mat-dialog-content class="window">
  <!--<div [froalaEditor]="options" (froalaInit)="initialize($event)" [(froalaModel)]="textHtml">
  </div>-->
  <angular-editor  [(ngModel)]="htmlContent"  [config]="config"></angular-editor> 
</div> 
<div mat-dialog-actions>
  <button  mat-raised-button color="primary" (click)="onClose()">Save</button>
</div>

